"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sant-anatolia-di-narco": {
    "025ed620": [{
      "hkey": "a8b64dae",
      "slug": "sant-anatolia-di-narco",
      "name": "Sant'Anatolia di Narco",
      "primary": true,
      "skipSearch": false
    }],
    "tassinare": [{
      "hkey": "a8b64dae",
      "slug": "sant-anatolia-di-narco",
      "name": "Sant'Anatolia di Narco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;